import { filter } from "lodash";
import React, { useEffect, useState } from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Box, Flex } from "rebass";
import { systemActions, yodaOrdersActions } from "../../logic/actions";
import { getLocalizedString } from "../../utils";
import config from "../../utils/globalConfig";
import { ToastMessage } from "../order/ToastMessage";
import { MiniCartItem } from "./MiniCartItem";
import MiniCartItemMobile from "./MiniCartItemMobile";
import { Price } from "../common/Price";
import useResponsive from "../../hooks/useResponsive";
import { CalculatorBlkSVG, CalculatorWhtSVG } from "../../icons/Calculator";
import { stringHtmlConverter } from "../../utils/stringHtmlConverter";
const MiniCart = () => {
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 3,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  const amountColors = {
    error: "#F04836",
    success: "#249D4E",
    warning: "#E3BE24",
  };

  const navigate = useHistory();
  const dispatch = useDispatch();
  const { isMobile } = useResponsive();

  const {
    order,
    orderRowDetails,
    orderDetails,
    totalReorder,
    totalSwap,
    maxSwap,
    showDebug,
    debugInfo,
  } = useSelector((state) => state.yodaOrders);
  const { budget } = useSelector((state) => state.yodaBudget);

  const { tab } = useSelector((state) => state.system);

  const [qtyReorder, setQtyReorder] = useState(0);
  const [qtySwap, setQtySwap] = useState(0);
  const [viewedCatalog, setViewedCatalog] = useState([]);

  const [miniCartTab, setMiniCartTab] = useState(tab);
  const [deleteMessage, setDeleteMessage] = useState(null);

  const [deleteOrderId, setDeleteOrderId] = useState(null);
  const [deleteProductId, setDeleteProductId] = useState(null);
  const [deleteModelCode, setDeleteModelCode] = useState(null);

  const orderTypeSwap = config.ORDER_TYPE_SWAP;

  const reorderExcess = budget?.maxRestock
    ? totalReorder > budget?.maxRestock
    : false;

  const swapExcess = maxSwap < 0;

  useEffect(() => {
    window.addEventListener("MINICART_DELETE", minicartDeleteHandle);

    return () => {
      window.removeEventListener("MINICART_DELETE", minicartDeleteHandle);
    };
  });

  useEffect(() => {
    if (orderRowDetails) {
      let f = filter(orderRowDetails, (k, v) => true);
      setQtyReorder(
        f
          .filter((o) => o?.customData?.typeId == config.ORDER_TYPE_REORDER)
          .reduce((prev, curr) => prev + curr.quantity, 0),
      );
      setQtySwap(
        f
          .filter((o) => o?.customData?.typeId == config.ORDER_TYPE_SWAP)
          .reduce((prev, curr) => prev + curr.quantity, 0),
      );

      orderDetailsFiltered();
    }
  }, [miniCartTab, orderRowDetails, orderDetails]);

  useEffect(() => {
    setMiniCartTab(tab);
  }, [tab]);

  useEffect(() => {
    if (miniCartTab == 2 && showDebug && debugInfo) {
      const debugContent = document.getElementById("debugContent");
      debugContent.innerHTML = "";
      debugContent.appendChild(stringHtmlConverter(debugInfo));
    }
  }, [showDebug, debugInfo, miniCartTab]);

  function minicartDeleteHandle(evt) {
    setDeleteMessage(evt.detail.message);
    setDeleteOrderId(evt.detail.orderId);
    setDeleteProductId(evt.detail.productId);
    setDeleteModelCode(evt.detail.modelCode);
  }

  function orderDetailsFiltered() {
    const orderType =
      miniCartTab === 0 ? config.ORDER_TYPE_REORDER : config.ORDER_TYPE_SWAP;
    const returnCatalog = Object.values(orderDetails || {}).reduce(
      (prev, curr) => {
        if (
          curr.orderTypeId === orderType &&
          !prev.find((order) => order.productId === curr.productId)
        )
          prev.push(curr);
        return prev;
      },
      [],
    );
    setViewedCatalog(returnCatalog);
  }

  function navigateToOrderDetail() {
    dispatch(systemActions.toggleMobileNavButton(false));
    navigate.push("/orderDetail/" + order.id);
  }

  return isMobile ? (
    <>
      <ToastMessage
        message={deleteMessage}
        needConfirm={true}
        confirmFunction={(ev) => {
          dispatch(
            yodaOrdersActions.removeProduct(
              deleteOrderId,
              miniCartTab === 0
                ? config.ORDER_TYPE_REORDER
                : config.ORDER_TYPE_SWAP,
              deleteProductId,
              deleteModelCode,
            ),
          );
          setDeleteMessage(null);
          ev.preventDefault();
          ev.stopPropagation();
          ev.nativeEvent.stopImmediatePropagation();
        }}
        cancelFunction={(ev) => {
          setDeleteMessage(null);
          ev.preventDefault();
          ev.stopPropagation();
          ev.nativeEvent.stopImmediatePropagation();
        }}
        style={{ width: 600 }}
      />
      <Flex bg="#fff" flexDirection="column" height="100dvh">
        <Flex
          width={1}
          mb={3}
          mt="-1px"
          height={45}
          justifyContent="left"
          alignItems="center"
          style={{ borderBottom: "1px solid white" }}
          bg="#a2a2a2"
        >
          <Flex
            bg={miniCartTab == 0 ? "white" : ""}
            color={miniCartTab == 0 ? "black" : "white"}
            width={130}
            alignItems="center"
            justifyContent="center"
            height={40}
            style={{
              fontSize: "1em",
              top: "2px",
              position: "relative",
            }}
            onClick={() => {
              if (miniCartTab == 1) {
                setMiniCartTab(0);
                dispatch(systemActions.setTab(0));
              }
            }}
          >
            {getLocalizedString("REORDER")}
          </Flex>
          {order?.orderTypeId == orderTypeSwap && (
            <Flex
              p={0}
              width={130}
              bg={miniCartTab == 1 ? "white" : ""}
              color={miniCartTab == 1 ? "black" : "white"}
              alignItems="center"
              justifyContent="center"
              height={40}
              style={{
                fontSize: "1em",
                top: "2px",
                position: "relative",
              }}
              onClick={() => {
                if (miniCartTab == 0) {
                  setMiniCartTab(1);
                  dispatch(systemActions.setTab(1));
                }
              }}
            >
              {getLocalizedString("SWAP_TAB")}
            </Flex>
          )}
        </Flex>

        <Flex overflowX="scroll" overflowY="hidden" pb="10px">
          {Object.keys(orderRowDetails).length > 0 ? (
            viewedCatalog.map((detail, i) => {
              return (
                <MiniCartItemMobile
                  key={i}
                  orderId={order?.id}
                  {...{ qtyReorder, totalReorder, qtySwap, totalSwap }}
                  {...detail}
                />
              );
            })
          ) : (
            <Flex
              sx={{
                flexDirection: "column",
                gap: "40px",
                alignItems: "center",
                width: "100%",
                flex: 1,
                my: "40px",
              }}
            >
              <Flex
                justifyContent={"center"}
                fontSize={12}
                sx={{
                  flexDirection: "column",
                  alignItems: "center",
                  color: "#232323",
                  gap: "16px",
                }}
              >
                <Box>{getLocalizedString("Carrello vuoto 1")}</Box>
                <Box>{getLocalizedString("Carrello vuoto 2")}</Box>
              </Flex>
              <Flex
                width={1}
                height="100%"
                justifyContent="center"
                alignItems="center"
              >
                <Box width="95%">
                  <button
                    style={{
                      width: "100%",
                      padding: "12px",
                      fontSize: "1em",
                      letterSpacing: "1px",
                      textTransform: "uppercase",
                      backgroundColor: "#232323",
                      color: "#fff",
                      borderRadius: "5px",
                    }}
                    onClick={navigateToOrderDetail}
                  >
                    {getLocalizedString("Visualizza carrello")}
                  </button>
                </Box>
              </Flex>
            </Flex>
          )}
        </Flex>

        <Flex mt={3} flexDirection={"column"} alignItems="center" bg="#f2f2f2">
          {orderRowDetails && Object.keys(orderRowDetails).length > 0 && (
            <Flex
              flexDirection="column"
              width={1}
              p="10px"
              fontSize={"1.2em"}
              height="calc(100vh - 345px)"
            >
              <Flex width={1} py="10px">
                <Flex width={1} mr={2} justifyContent="center">
                  <span style={{ color: "black", fontWeight: "bold" }}>
                    {getLocalizedString("CART SUMMARY")}
                  </span>
                </Flex>
                <Box
                  style={{ minWidth: 1 }}
                  backgroundColor="transparent"
                ></Box>
                <Flex width={1 / 3} mr={2} justifyContent="center">
                  <span style={{ color: "black", fontWeight: "bold" }}>
                    {getLocalizedString("QTA")}
                  </span>
                </Flex>
                <Box
                  style={{ minWidth: 1 }}
                  backgroundColor="transparent"
                ></Box>
                <Flex
                  width={2 / 3}
                  fontSize={"1em"}
                  justifyContent="center"
                ></Flex>
              </Flex>
              <Flex width={1}>
                <Flex
                  width={1}
                  fontSize={"1em"}
                  mr={2}
                  style={{ color: "#fff", opacity: 0.7, marginLeft: "-7px" }}
                  justifyContent="flex-end"
                  p={2}
                >
                  <span style={{ color: "#616161" }}>
                    {getLocalizedString("REORDER")}
                  </span>
                </Flex>
                <Box style={{ minWidth: 1 }} backgroundColor="#878787"></Box>
                <Flex
                  width={1 / 3}
                  fontSize={"1em"}
                  mr={2}
                  style={{ color: "#fff", opacity: 0.7 }}
                  justifyContent="center"
                  p={2}
                >
                  <span style={{ color: "#616161" }}>{qtyReorder}</span>
                </Flex>
                <Box style={{ minWidth: 1 }} backgroundColor="#878787"></Box>
                <Flex
                  width={2 / 3}
                  fontSize={"1em"}
                  justifyContent="center"
                  p={2}
                >
                  <Box
                    p={1}
                    pl={2}
                    backgroundColor={
                      reorderExcess ? amountColors.error : amountColors.success
                    }
                    minWidth={50}
                    justifyContent="center"
                  >
                    {orderRowDetails &&
                      Object.keys(orderRowDetails).length > 0 && (
                        <Price price={totalReorder} />
                      )}
                  </Box>
                </Flex>
              </Flex>
              <Box
                style={{ height: 1 }}
                width={1}
                backgroundColor="#878787"
              ></Box>
              {order?.orderTypeId == config.ORDER_TYPE_SWAP && (
                <Flex width={1}>
                  <Flex
                    width={1}
                    fontSize={"1em"}
                    mr={2}
                    style={{ color: "#fff", opacity: 0.7, marginLeft: "-7px" }}
                    justifyContent="flex-end"
                    p={2}
                  >
                    <span style={{ color: "#616161" }}>
                      {getLocalizedString("RETURN")}
                    </span>
                  </Flex>
                  <Box style={{ minWidth: 1 }} backgroundColor="#878787"></Box>
                  <Flex
                    width={1 / 3}
                    fontSize={"1em"}
                    mr={2}
                    style={{ color: "#fff", opacity: 0.7 }}
                    justifyContent="center"
                    p={2}
                  >
                    <span style={{ color: "#616161" }}>{qtySwap}</span>
                  </Flex>
                  <Box style={{ minWidth: 1 }} backgroundColor="#878787"></Box>
                  <Flex
                    width={2 / 3}
                    fontSize={"1em"}
                    justifyContent="center"
                    p={2}
                  >
                    <Box
                      p={1}
                      pl={2}
                      backgroundColor={
                        swapExcess ? amountColors.error : amountColors.success
                      }
                      minWidth={50}
                      justifyContent="center"
                    >
                      {orderRowDetails &&
                        Object.keys(orderRowDetails).length > 0 && (
                          <Price price={totalSwap} />
                        )}
                    </Box>
                  </Flex>
                </Flex>
              )}
              {order?.orderTypeId == config.ORDER_TYPE_SWAP && (
                <Box
                  style={{ height: 1 }}
                  width={1}
                  backgroundColor="#878787"
                ></Box>
              )}
              {order?.orderTypeId == config.ORDER_TYPE_SWAP && (
                <Flex width={1}>
                  <Flex
                    width={1}
                    fontSize={"1em"}
                    mr={2}
                    style={{ color: "#fff", opacity: 0.7, marginLeft: "-7px" }}
                    justifyContent="flex-end"
                    p={2}
                  >
                    <span style={{ color: "#616161" }}>
                      {getLocalizedString("RETURN THRESHOLD")}
                    </span>
                  </Flex>
                  <Box style={{ minWidth: 1 }} backgroundColor="#878787"></Box>
                  <Flex
                    width={1 / 3}
                    fontSize={"1em"}
                    mr={2}
                    style={{ color: "#fff", opacity: 0.7 }}
                    justifyContent="center"
                    p={2}
                  ></Flex>
                  <Box style={{ minWidth: 1 }} backgroundColor="#878787"></Box>
                  <Flex
                    width={2 / 3}
                    fontSize={"1em"}
                    justifyContent="center"
                    p={2}
                  >
                    <Box
                      p={1}
                      pl={2}
                      pr={2}
                      color="black"
                      minWidth={50}
                      justifyContent="center"
                    >
                      {orderRowDetails &&
                        Object.keys(orderRowDetails).length > 0 &&
                        order.orderTypeId == config.ORDER_TYPE_SWAP && (
                          <Price
                            price={Number(totalReorder) - Number(totalSwap)}
                          />
                        )}
                      {orderRowDetails &&
                        Object.keys(orderRowDetails).length > 0 &&
                        order.orderTypeId == config.ORDER_TYPE_REORDER && (
                          <Price price={0} />
                        )}
                    </Box>
                  </Flex>
                </Flex>
              )}
              {orderRowDetails && Object.keys(orderRowDetails).length > 0 && (
                <Box width="100%" mt="40px">
                  <button
                    style={{
                      width: "100%",
                      padding: "12px",
                      fontSize: "1em",
                      letterSpacing: "1px",
                      textTransform: "uppercase",
                      backgroundColor: "#232323",
                      color: "#fff",
                      borderRadius: "5px",
                    }}
                    onClick={navigateToOrderDetail}
                  >
                    {getLocalizedString("Visualizza carrello")}
                  </button>
                </Box>
              )}
            </Flex>
          )}
        </Flex>
      </Flex>
      {/* <Box height="100dvh" width="100vw" bg="#fff"></Box> */}
    </>
  ) : (
    <Box style={{ fontSize: "0.8em", color: "#FFF" }}>
      <ToastMessage
        message={deleteMessage}
        needConfirm={true}
        confirmFunction={(ev) => {
          dispatch(
            yodaOrdersActions.removeProduct(
              deleteOrderId,
              miniCartTab === 0
                ? config.ORDER_TYPE_REORDER
                : config.ORDER_TYPE_SWAP,
              deleteProductId,
              deleteModelCode,
            ),
          );
          setDeleteMessage(null);
          ev.preventDefault();
          ev.stopPropagation();
          ev.nativeEvent.stopImmediatePropagation();
        }}
        cancelFunction={(ev) => {
          setDeleteMessage(null);
          ev.preventDefault();
          ev.stopPropagation();
          ev.nativeEvent.stopImmediatePropagation();
        }}
        style={{ width: 600 }}
      />
      <Flex
        width={1}
        mt={1}
        mr={3}
        mb={3}
        height={45}
        justifyContent="left"
        alignItems="center"
        style={{ borderBottom: "1px solid white" }}
      >
        <Flex
          p={0}
          bg={miniCartTab == 0 ? "white" : ""}
          color={miniCartTab == 0 ? "black" : "white"}
          width={130}
          alignItems="center"
          justifyContent="center"
          height={40}
          style={{
            fontSize: "1em",
            top: "2px",
            position: "relative",
            cursor: miniCartTab == 0 ? "" : "pointer",
          }}
          onClick={() => {
            setMiniCartTab(0);
            dispatch(systemActions.setTab(0));
          }}
        >
          {getLocalizedString("REORDER")}
        </Flex>
        {order?.orderTypeId == orderTypeSwap && (
          <Flex
            p={0}
            width={130}
            bg={miniCartTab == 1 ? "white" : ""}
            color={miniCartTab == 1 ? "black" : "white"}
            alignItems="center"
            justifyContent="center"
            height={40}
            style={{
              fontSize: "1em",
              top: "2px",
              position: "relative",
              cursor: miniCartTab == 1 ? "" : "pointer",
            }}
            onClick={() => {
              setMiniCartTab(1);
              dispatch(systemActions.setTab(1));
            }}
          >
            {getLocalizedString("SWAP_TAB")}
          </Flex>
        )}

        {showDebug && (
          <Flex
            p={0}
            width={130}
            bg={miniCartTab == 2 ? "white" : ""}
            color={miniCartTab == 2 ? "black" : "white"}
            alignItems="center"
            justifyContent="center"
            height={40}
            style={{
              fontSize: "1em",
              top: "2px",
              position: "relative",
              cursor: miniCartTab == 2 ? "" : "pointer",
            }}
            onClick={() => {
              setMiniCartTab(2);
            }}
          >
            {miniCartTab == 2 && (
              <CalculatorBlkSVG style={{ width: "20px", height: "20px" }} />
            )}
            {miniCartTab !== 2 && (
              <CalculatorWhtSVG style={{ width: "20px", height: "20px" }} />
            )}
          </Flex>
        )}
      </Flex>
      <Carousel responsive={responsive}>
        {orderRowDetails &&
          Object.keys(orderRowDetails).length > 0 &&
          viewedCatalog.map((detail, i) => {
            if (detail) {
              return (
                <MiniCartItem
                  key={i}
                  orderId={order?.id}
                  style={{ marginRight: 2, marginLeft: 4 }}
                  {...detail}
                />
              );
            }
          })}
      </Carousel>
      {miniCartTab == 2 && showDebug && (
        <div style={{ minHeight: "200px" }} id={"debugContent"}></div>
      )}
      <Flex
        mt={3}
        style={{ marginBottom: "24px" }}
        flexDirection={"column"}
        alignItems="center"
        display={miniCartTab == 2 ? "none" : "block"}
      >
        {orderRowDetails && Object.keys(orderRowDetails).length > 0 && (
          <React.Fragment>
            <Flex width={1}>
              <Flex width={1} mr={2} fontSize={"1em"} justifyContent="center">
                <strong>{getLocalizedString("CART SUMMARY")}</strong>
              </Flex>
              <Box style={{ minWidth: 1 }} backgroundColor="transparent"></Box>
              <Flex
                width={1 / 3}
                mr={2}
                fontSize={"1em"}
                justifyContent="center"
              >
                <strong>{getLocalizedString("QTA")}</strong>
              </Flex>
              <Box style={{ minWidth: 1 }} backgroundColor="transparent"></Box>
              <Flex
                width={2 / 3}
                fontSize={"1em"}
                justifyContent="center"
              ></Flex>
            </Flex>
            <Flex width={1}>
              <Flex
                width={1}
                fontSize={"1em"}
                mr={2}
                style={{ color: "#fff", opacity: 0.7, marginLeft: "-7px" }}
                justifyContent="flex-end"
                p={2}
              >
                {getLocalizedString("REORDER")}
              </Flex>
              <Box style={{ minWidth: 1 }} backgroundColor="#878787"></Box>
              <Flex
                width={1 / 3}
                fontSize={"1em"}
                mr={2}
                style={{ color: "#fff", opacity: 0.7 }}
                justifyContent="center"
                p={2}
              >
                {qtyReorder}
              </Flex>
              <Box style={{ minWidth: 1 }} backgroundColor="#878787"></Box>
              <Flex
                width={2 / 3}
                fontSize={"1em"}
                justifyContent="center"
                p={2}
              >
                <Box
                  p={1}
                  pl={2}
                  backgroundColor={
                    reorderExcess ? amountColors.error : amountColors.success
                  }
                  minWidth={50}
                  justifyContent="center"
                >
                  {orderRowDetails &&
                    Object.keys(orderRowDetails).length > 0 && (
                      <Price price={totalReorder} />
                    )}
                </Box>
              </Flex>
            </Flex>
            <Box
              style={{ height: 1 }}
              width={1}
              backgroundColor="#878787"
            ></Box>
            {order?.orderTypeId == config.ORDER_TYPE_SWAP && (
              <Flex width={1}>
                <Flex
                  width={1}
                  fontSize={"1em"}
                  mr={2}
                  style={{ color: "#fff", opacity: 0.7, marginLeft: "-7px" }}
                  justifyContent="flex-end"
                  p={2}
                >
                  {getLocalizedString("RETURN")}
                </Flex>
                <Box style={{ minWidth: 1 }} backgroundColor="#878787"></Box>
                <Flex
                  width={1 / 3}
                  fontSize={"1em"}
                  mr={2}
                  style={{ color: "#fff", opacity: 0.7 }}
                  justifyContent="center"
                  p={2}
                >
                  {qtySwap}
                </Flex>
                <Box style={{ minWidth: 1 }} backgroundColor="#878787"></Box>
                <Flex
                  width={2 / 3}
                  fontSize={"1em"}
                  justifyContent="center"
                  p={2}
                >
                  <Box
                    p={1}
                    pl={2}
                    backgroundColor={
                      swapExcess ? amountColors.error : amountColors.success
                    }
                    minWidth={50}
                    justifyContent="center"
                  >
                    {orderRowDetails &&
                      Object.keys(orderRowDetails).length > 0 && (
                        <Price price={totalSwap} />
                      )}
                  </Box>
                </Flex>
              </Flex>
            )}
            {order?.orderTypeId == config.ORDER_TYPE_SWAP && (
              <Box
                style={{ height: 1 }}
                width={1}
                backgroundColor="#878787"
              ></Box>
            )}
            {order?.orderTypeId == config.ORDER_TYPE_SWAP && (
              <Flex width={1}>
                <Flex
                  width={1}
                  fontSize={"1em"}
                  mr={2}
                  style={{ color: "#fff", opacity: 0.7, marginLeft: "-7px" }}
                  justifyContent="flex-end"
                  p={2}
                >
                  {getLocalizedString("RETURN THRESHOLD")}
                </Flex>
                <Box style={{ minWidth: 1 }} backgroundColor="#878787"></Box>
                <Flex
                  width={1 / 3}
                  fontSize={"1em"}
                  mr={2}
                  style={{ color: "#fff", opacity: 0.7 }}
                  justifyContent="center"
                  p={2}
                ></Flex>
                <Box style={{ minWidth: 1 }} backgroundColor="#878787"></Box>
                <Flex
                  width={2 / 3}
                  fontSize={"1em"}
                  justifyContent="center"
                  p={2}
                >
                  <Box
                    p={1}
                    pl={2}
                    pr={2}
                    color="#FFFFFF"
                    minWidth={50}
                    justifyContent="center"
                  >
                    {orderRowDetails &&
                      Object.keys(orderRowDetails).length > 0 &&
                      order.orderTypeId == config.ORDER_TYPE_SWAP && (
                        <Price price={maxSwap} />
                      )}
                    {orderRowDetails &&
                      Object.keys(orderRowDetails).length > 0 &&
                      order.orderTypeId == config.ORDER_TYPE_REORDER && (
                        <Price price={totalSwap} />
                      )}
                  </Box>
                </Flex>
              </Flex>
            )}
          </React.Fragment>
        )}
      </Flex>
      {orderRowDetails && Object.keys(orderRowDetails).length >= 0 && (
        <Box>
          {orderRowDetails && Object.keys(orderRowDetails).length === 0 && (
            <>
              <Flex
                justifyContent={"center"}
                mb={2}
                fontSize={12}
                style={{ marginTop: "-20px" }}
              >
                {getLocalizedString("Carrello vuoto 1")}
              </Flex>
              <Flex
                justifyContent={"center"}
                mb={2}
                fontSize={12}
                style={{ marginBottom: "30px" }}
              >
                {getLocalizedString("Carrello vuoto 2")}
              </Flex>
            </>
          )}
          <button
            style={{
              width: "100%",
              padding: "12px",
              fontSize: "1em",
              letterSpacing: "1px",
              textTransform: "uppercase",
              backgroundColor: "#FFF",
              color: "#000",
              borderRadius: "5px",
            }}
            onClick={navigateToOrderDetail}
          >
            {getLocalizedString("Visualizza carrello")}
          </button>
        </Box>
      )}
    </Box>
  );
};

export default MiniCart;
